module.exports = __webpack_public_path__ + "d246ce71868dbcd4ca7dbcd93fb31fe4.png";